"use strict";
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var render_1 = require("./utils/render");
// import { GlobalStyles } from "./globalStyles";
exports.Player = function (_a) {
    var data = _a.data, root = _a.root;
    var renderer = render_1.Renderer(root, data);
    var children = react_1.useMemo(function () { return renderer.renderRoot(); }, [data]);
    return (react_1.default.createElement(react_1.default.Fragment, null, children));
};
